export enum AttachmentsFilterEnum {
  Yes = "yes",
  No = "no",
}

export const AttachmentsFilterEnumMap = {
  fromQueryString: {
    true: AttachmentsFilterEnum.Yes,
    false: AttachmentsFilterEnum.No,
  },
  toQueryString: {
    [AttachmentsFilterEnum.No]: false,
    [AttachmentsFilterEnum.Yes]: true,
  },
};
